<template>
  <div>
    <h1 class="page-header">Product</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label">Product Name KH</label>
                <div class="col-md-7">
                  <input
                    v-model="model.product_name_kh"
                    type="text"
                    ref="product_name_kh"
                    class="form-control kh-font"
                    :class="{ 'is-invalid': errors.has('product_name_kh') }"
                    placeholder="Product name kh"
                  />
                  <div class="invalid-feedback" v-if="errors.has('product_name_kh')">
                    {{ errors.first('product_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label "
                  >Company Name EN <span class="text-danger">*</span>
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.product_name_en"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('product_name_en') }"
                    placeholder="Product name en"
                  />
                  <div class="invalid-feedback" v-if="errors.has('product_name_en')">
                    {{ errors.first('product_name_en') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> Category <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <select
                    v-model.number="model.category_id"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('category_id') }"
                  >
                    <option value="">--select--</option>
                    <option v-for="(category, index) in categories" :key="index" :value="category.category_id">
                      {{ category.category_name_en }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('category_id')">
                    {{ errors.first('category_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> UOM <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <select
                    v-model.number="model.uom_id"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('uom_id') }"
                  >
                    <option value="">--select--</option>
                    <option v-for="(unit_measure, index) in unit_measures" :key="index" :value="unit_measure.uom_id">
                      {{ unit_measure.uom_name_en }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('uom_id')">
                    {{ errors.first('uom_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> Saling Price <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <input
                    v-model.number="model.saling_price"
                    type="number"
                    step="any"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('saling_price') }"
                    placeholder="Please enter saling price"
                  />
                  <div class="invalid-feedback" v-if="errors.has('saling_price')">
                    {{ errors.first('saling_price') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> Re-order min <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <input
                    v-model.number="model.reorder_min"
                    type="number"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('reorder_min') }"
                    placeholder="Enter re-order min"
                  />
                  <div class="invalid-feedback" v-if="errors.has('reorder_min')">
                    {{ errors.first('reorder_min') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> Re-order max <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <input
                    v-model.number="model.reorder_max"
                    type="number"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('reorder_max') }"
                    placeholder="Enter re-order max"
                  />
                  <div class="invalid-feedback" v-if="errors.has('reorder_max')">
                    {{ errors.first('reorder_max') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Product Photo</label>
                <div class="col-md-7">
                  <div id="img-frame">
                    <label for="photo_file" id="label_photo_file">
                      <img :src="photo_file_src" alt="" />
                    </label>
                    <input type="file" id="photo_file" ref="photo_file" accept="image/*" @change="onFileSelected" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> Inventory Type <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <select
                    v-model.number="model.inv_type_id"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('inv_type_id') }"
                    @change="inventoryTypeChange"
                  >
                    <option value="">--select--</option>
                    <option v-for="(inv, index) in inventory_types" :key="index" :value="inv.inv_type_id">
                      {{ inv.inventory_type }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('inv_type_id')">
                    {{ errors.first('inv_type_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15" v-if="model.inv_type_id == 3">
                <label class="col-md-5 col-form-label">Product Assembly</label>
                <div class="col-md-7">
                  <i class="fas fa-spinner spin mt-2 fa-2x" v-if="!show_add_list_assembly"></i>
                  <table class="table table-hover ui-table table-responsive" v-if="show_add_list_assembly">
                    <thead>
                      <tr>
                        <th class="width-77">PRODDUCT</th>
                        <th>QUANTITY</th>
                        <th class="text-center">
                          <a href="#" @click="addAssembly"><i class="fas fa-plus"></i></a>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(assembly_row, index) in model.assembly_detail" :key="index">
                        <th>
                          <select
                            class="form-control"
                            v-model="assembly_row.product_id"
                            :class="{
                              'is-invalid': errors.has('assembly_detail.' + index + '.product_id')
                            }"
                          >
                            <option value="">--select--</option>
                            <option
                              v-for="(assembly_product, index) in assembly_products"
                              :key="index"
                              :value="assembly_product.product_id"
                            >
                              {{ assembly_product.product_name_en }}
                            </option>
                          </select>
                          <div class="invalid-feedback" v-if="errors.has('assembly_detail.' + index + '.product_id')">
                            {{ errors.first('assembly_detail.' + index + '.product_id') }}
                          </div>
                        </th>
                        <th>
                          <input
                            type="number"
                            class="form-control"
                            v-model="assembly_row.quantity"
                            :class="{
                              'is-invalid': errors.has('assembly_detail.' + index + '.quantity')
                            }"
                          />
                        </th>
                        <th class="text-right">
                          <ts-button flat @click="removeRow(assembly_row)">
                            <i class="fas fa-trash text-danger"></i>
                          </ts-button>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row  pull-right">
            <div class="col-lg-12 form-group">
              <ts-button color="primary" :waiting="save_new" @click="saveAddNew">
                Save Add New
              </ts-button>

              <ts-button class="ml-2" color="primary" :waiting="saving" @click="store">
                Save
              </ts-button>
              <ts-button class="ml-2" @click="$router.push({ name: 'product' })">
                Cancel
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'product-create-form',
  data() {
    return {
      model: {
        product_name_kh: '',
        product_name_en: '',
        category_id: '',
        uom_id: '',
        reorder_min: '',
        reorder_max: '',
        photo: '',
        inv_type_id: '',
        saling_price: '',
        assembly_detail: []
      },
      add_new_row: { product_id: '', quantity: '' },
      show_add_list_assembly: false,
      file: '',
      errors: new Errors(),
      saving: false,
      save_new: false,
      photo_file_src: 'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
    }
  },
  mounted() {
    this.$refs.product_name_kh.focus()
  },
  created() {},
  computed: {
    ...mapState('inventory/product', ['categories', 'unit_measures', 'inventory_types', 'assembly_products'])
  },
  methods: {
    async saveAddNew() {
      this.errors.clear()
      this.save_new = true
      let file_upload_path = await this.uploadLogo()
      try {
        let response = await this.$store.dispatch(
          'product/store',
          Object.assign({}, this.model, { photo: file_upload_path })
        )
        await this.$store.dispatch('inventory/product/getAssemblyProduct')
        this.save_new = false
        this.clearForm()
        this.$toasted.success(response.message)
        this.clearForm()
        this.$refs.product_name_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.save_new = false
      }
    },

    async store() {
      this.errors = new Errors()
      this.saving = true
      let file_upload_path = await this.uploadLogo()
      this.$store
        .dispatch('inventory/product/store', Object.assign({}, this.model, { photo: file_upload_path }))
        .then(response => {
          this.saving = false
          this.clearForm()
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.saving = false
          this.$toasted.error(error.message)
        })
    },

    uploadLogo() {
      this.file = this.$refs.photo_file.files[0] ? this.$refs.photo_file.files[0] : null
      if (this.file) {
        let formData = new FormData()
        formData.append('photo', this.file)
        return this.$store.dispatch('inventory/product/uploadPhoto', formData)
      }

      return ''
    },

    onFileSelected() {
      const file = this.$refs.photo_file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.photo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.photo_file_src = 'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'

          this.$toasted.error('invalid file type!')
          this.$refs.photo_file.value = ''
        }
      }
    },
    addAssembly() {
      this.errors.clear()
      this.model.assembly_detail.push(_.clone(this.add_new_row))
    },
    removeRow(row) {
      this.model.assembly_detail.splice(this.model.assembly_detail.indexOf(row), 1)
    },
    async inventoryTypeChange() {
      if (this.model.inv_type_id == 3) {
        await this.$store.dispatch('inventory/product/getAssemblyProduct')
        this.show_add_list_assembly = true
      } else {
        this.model.assembly_detail = []
        this.show_add_list_assembly = false
      }
    },
    clearForm() {
      this.model.product_name_kh = ''
      this.model.product_name_en = ''
      this.model.category_id = ''
      this.model.uom_id = ''
      this.model.reorder_min = ''
      this.model.reorder_max = ''
      this.model.photo = ''
      this.model.inv_type_id = ''
      this.model.saling_price = ''
      this.photo_file_src = 'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
      this.$refs.photo_file.value = ''
      this.model.assembly_detail = []
    }
  },
  watch: {},
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('inventory/product/RESET_STATE')
    }
    next()
  }
}
</script>

<style>
#photo_file {
  display: none;
}
#img-frame img {
  object-fit: contain;
  width: 110px;
  height: 108px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
}
#label_photo_file {
  cursor: pointer;
}
.width-77 {
  width: 77%;
}
</style>
